<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.refId')">
            <el-input
                v-model="form.referenceId"
                :placeholder="$t('message.inputRefId')"
                style="width: 260px"
                maxlength="50"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.transactionTime')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>
        <template slot="tableColumn">
          <el-table-column prop="referenceId"
                           width="160"
                           :label="$t('text.refId')"
                           align="center"/>
          <el-table-column prop="paymentChannel"
                           width="160"
                           :label="$t('text.paymentChannel')"
                           align="center"/>
          <el-table-column
              prop="productName"
              width="80px"
              :label="$t('text.transactionType')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div>{{ row.productId === '110' ? $t('text.collection') : $t('text.disbursement') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="upstream"
                           width="160"
                           :label="$t('text.upstream')"
                           align="center"/>
          <el-table-column prop="amount"
                           width="160"
                           :label="$t('text.amount')"
                           align="center"/>
          <el-table-column prop="receiverAccount"
                           width="200"
                           :label="$t('text.cardPaymentAccount')"
                           align="center"/>
          <el-table-column prop="receiverAccountType"
                           width="160"
                           :label="$t('text.receiverAccountType')"
                           align="center"/>
          <el-table-column prop="sourceAccount"
                           width="200"
                           :label="$t('text.sourceAccount')"
                           align="center"/>
          <el-table-column prop="transactionTime"
                           width="200"
                           :label="$t('text.transactionTime')"
                           align="center">
            <template slot-scope="{ row }">
              {{ $formatter.formatDate(null, null, row.transactionTime, null) }}
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/order/upstreamTransaction/selectList",
      timeDate: [],
      form: {
        referenceId: "",
        startTime: "",
        endTime: "",
      },
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startTime = e[0];
        this.form.endTime = e[1];
      } else {
        this.form.startTime = "";
        this.form.endTime = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
};
</script>